<div class="flex flex-col h-full">
  <p class="font-['Roboto'] font-bold text-xl/6 text-[#333333] tracking-2percent pb-6">{{ labels.stellar.signIn.bankAccount.enterBankAccountInfo}}</p>
  <form
    class="flex flex-col h-full justify-between"
    [formGroup]="bankAccountForm"
    (ngSubmit)="onSubmit(bankAccountForm.value)"
    *ngIf="bankAccountForm"
  >
    <div class="flex flex-col">
      <ng-container *ngFor="let gffpField of bankGFFPFields; index as i">
        <div class="flex flex-col gap-3">
          <label
            [for]="gffpField.field"
            class="font-bold tracking-3percen text-[12px] leading-4 text-[#737373]"
          >{{ gffpField.fieldLabel }}
          <span
            *ngIf="gffpField?.required"
            [class]="
              bankAccountForm.get(gffpField.field)?.errors?.required &&
              bankAccountForm.get(gffpField.field)?.invalid &&
              bankAccountForm.get(gffpField.field)?.touched
                ? 'text-[#da291c] transition-all duration-75'
                : null
            "
            >*</span>
          </label>
          <ng-container *ngIf="gffpField.field === 'targetAccountAccountType'; else elseInput">
            <app-custom-radio-input
              [labels]="labels"
              [isFormMode]="true"
              [selectedOptionId]="bankAccountForm.get(gffpField.field)?.value"
              [optionConfig]="optionConfig"
              (optionSelectEvent)="bankAccountForm.get(gffpField.field)?.setValue($event)"
            ></app-custom-radio-input>
          </ng-container>
          <ng-template #elseInput>
            <input
              class="form-input"
              type="text"
              [placeholder]="labels.stellar.signIn.userProfile.enter"
              [formControlName]="gffpField.field"
              [id]="gffpField.field"
            />
          </ng-template>
          <div *ngIf="!bankAccountForm.get(gffpField.field)?.disabled" class="-mt-[calc(16px-5.3866666672px)] w-full h-6">
            <div
              *ngIf="
                bankAccountForm.get(gffpField.field)?.invalid &&
                bankAccountForm.get(gffpField.field)?.touched
              "
              class="
                font-normal
                text-[13px]
                max-[430px]:text-[12px]
                text-[#da291c]
                w-full
              "
            >
              <ng-container *ngIf="bankAccountForm.get(gffpField.field)?.errors as errors; else noErrors">
                <div *ngIf="errors.required">
                  {{ gffpField.fieldLabel }} required.
                </div>
                <div *ngIf="!errors.required && errors.minlength">
                  Min length {{ gffpField.fieldMin }}.
                </div>
                <div *ngIf="!errors.required && !errors.minlength && errors.maxlength">
                  Max length {{ gffpField.fieldMax }}.
                </div>
                <div *ngIf="!errors.required && !errors.minlength && !errors.maxlength && errors.pattern">
                  {{ gffpField.fieldLabel }} is invalid.
                </div>
                <div *ngIf="!errors.required && !errors.minlength && !errors.maxlength && !errors.pattern && errors.invalidOption">
                  {{ gffpField.fieldLabel }} not found.
                </div>
                <div *ngIf="!errors.required && !errors.minlength && !errors.maxlength && !errors.pattern && !errors.invalidOption && errors.accountNumberMismatch && gffpField.field === 'targetAccountAccountNumberVerification'">
                  Account numbers do not match.
                </div>
              </ng-container>
              <ng-template #noErrors>
                <div class="h-full"></div>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div
      class="self-end w-full flex justify-start max-[430px]:justify-center items-center max-[430px]:pb-[30px] pb-12"
    >
      <button
        type="submit"
        [class]="
          bankAccountForm.invalid
            ? 'max-[430px]:continue-btn-disabled-mobile-outline continue-btn-disabled-desktop-outline'
            : 'max-[430px]:continue-btn-enabled-mobile-filled continue-btn-enabled-desktop-filled'
        "
        [disabled]="bankAccountForm.invalid"
      >
        <span
          [class]="bankAccountForm.invalid ? 'text-[#B3B3B3]' : 'text-[#FFFFFF]'"
          class="font-medium leading-6 tracking-3percen text-center transition-all"
        >
          {{ labels.stellar.signIn.continue }}
        </span>
      </button>
    </div>
  </form>
</div>
